<template>
	<v-card>
		<v-card-title>
			<v-spacer/>
			<v-spacer/>
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				:label="$t('pages.orderFilter.search')"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="users"
			:search="lookingFor"
			:sort-by.sync="sortBy"
			:loading="loading"
			class="elevation-1"
			:height="height"
			fixed-header
			mobile-breakpoint="0"
		>
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<user-row slot="item" slot-scope="props" @edit="onEdit" :user="props.item"/>
		</v-data-table>
	</v-card>
</template>

<script>
	import UserRow from "src/view/users/UserRow";
	import {types} from "src/store/modules/User.module";
	import FilterAble from "src/mixins/FilterAble";

	export default {
		name: "users-table",
		props: ["type"],
		components: {
			UserRow
		},
		mixins: [new FilterAble(types)],
		data () {
			return {
				lookingFor: "",
				sortBy: "name",
				loading: false,
				headers: [
					{text: this.$t("pages.userForm.firstName"), value: "name"},
					{text: this.$t("pages.userForm.lastName"), value: "last_name"},
					{text: this.$t("attributes.email"), value: "email"},
					{text: this.$t("attributes.customerName"), value: "clients_name"},
					{text: this.$t("pages.projectForm.branch"), value: "branch"},
					{text: this.$t("pages.roleSelect"), value: "role"}

				],
				filters: {
					role: this.type
				},
				showDialog: false,
				height: 200
			};
		},
		computed: {
			users() {
				return this.$store.state.UserModule.users;
			}
		},
		methods: {
			onEdit(User) {
				this.$emit("edit", User);
			},

		},
		mounted() {
			this.height = window.innerHeight - 100 - this.$el.getBoundingClientRect().y;
		},
		watch: {
			type: function () {
				this.filters.role = this.type;
				this.getData();
			}

		}

	};
</script>

<style>

</style>
